var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external_view_FinishPaper"},[(_vm.show)?_c('CommonFinishPaper',{ref:"commonFinishPaper",attrs:{"autoid":_vm.mautoid,"username":_vm.username}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }